import { motion, useScroll, useSpring } from "framer-motion";

// 2px red bar fixed to the very top of the viewport, filling as the user scrolls.
export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 220, damping: 40, mass: 0.3 });
  return (
    <motion.div
      aria-hidden
      data-testid="scroll-progress"
      className="fixed left-0 top-0 z-[9999] h-[2px] w-full origin-left bg-owo-red"
      style={{ scaleX }}
    />
  );
};
